import {
    unsubscribeDialogTitleTextV2,
    unsubscribeDialogSubTitleTextV2,
} from './onUnsubscribeFromInfoBarOrchestrator.locstring.json';
import { cancelButton } from 'owa-locstrings/lib/strings/cancelbutton.locstring.json';
import { okButton } from 'owa-locstrings/lib/strings/okbutton.locstring.json';
import loc, { format } from 'owa-localize';
import { BrandSubscriptionModel, unsubscribeFromBrandSubscription } from 'owa-brands-subscription';

import { confirm, ConfirmCustomizationOptions, DialogResponse } from 'owa-confirm-dialog';

import { ItemViewState } from 'owa-mail-reading-pane-store';
import { orchestrator } from 'satcheljs';

import unsubscribeEmailV2 from '../actions/unsubscribeEmailV2';
import removeInfoBarMessageInReadingPane from 'owa-info-bar/lib/actions/removeInfoBarMessage';

orchestrator(unsubscribeEmailV2, actionMessage => {
    confirm(
        loc(unsubscribeDialogTitleTextV2),
        format(loc(unsubscribeDialogSubTitleTextV2), actionMessage.message.From.Mailbox.Name),
        false /* resolevImmediately */,
        <ConfirmCustomizationOptions>{
            okText: loc(okButton),
            cancelText: loc(cancelButton),
        }
    ).then(async (response: DialogResponse) => {
        if (response === DialogResponse.ok) {
            unsubscribeWithoutConfirmDialog(actionMessage.cacheEntry, actionMessage.itemViewState);
        }
    });
});

function unsubscribeWithoutConfirmDialog(
    cacheEntry: BrandSubscriptionModel,
    itemViewState: ItemViewState
) {
    unsubscribeFromBrandSubscription(
        'ReadingPaneInfoBar',
        cacheEntry.smtpInfo.smtpIdentifier,
        cacheEntry.unsubscribeSilentUris,
        cacheEntry.unsubscribeHttpUris[0],
        () => {
            removeInfoBarMessageInReadingPane(itemViewState, 'unsubscribeInfoBar');
        }
    );
}
